// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"989137ef","112":"25354167","340":"6d4f152a","530":"989137ef"}[chunkId] + ".chunk.css";
};